import styled from "styled-components";
import { Portal, PortalCredential } from "@samacare/graphql";
import {
  InnerTableHeader,
  TableCell,
  TableRow,
} from "app/routes/Admin/AdminStyles";
import { Edit } from "@@ui-kit/Icons";
import * as React from "react";
import { WhiteButton } from "@@ui-kit/WhiteButton";
import { LeftRightCenterAll } from "@samacare/component";

const PortalCredentialTableRow = styled(TableRow)`
  &:hover {
    cursor: default;
  }
`;

interface IPortalCredentialRowProps {
  portalCredential: PortalCredential;
  onEdit: (portal: Portal, cred: PortalCredential | null) => void;
  portal: Portal;
}
export const PortalCredentialRow: React.FC<IPortalCredentialRowProps> = ({
  portal,
  portalCredential,
  onEdit,
}) => {
  return (
    <PortalCredentialTableRow id="pendo_portalRow">
      <TableCell id="pendo_portalRow_portalName">{portal?.title}</TableCell>
      <TableCell
        id="pendo_portalRow_actionButtons"
        style={{ padding: "16px 0px" }}
      >
        <InnerTableHeader
          style={{ justifyContent: "flex-end", padding: "0px 16px 0 0" }}
        >
          {portalCredential == null && (
            <WhiteButton onClick={() => onEdit(portal, null)}>
              Setup
            </WhiteButton>
          )}
          {portalCredential != null && (
            <WhiteButton onClick={() => onEdit(portal, portalCredential)}>
              <LeftRightCenterAll>
                <Edit size={18} style={{ marginRight: "8px" }} />
                {portalCredential.username}
              </LeftRightCenterAll>
            </WhiteButton>
          )}
        </InnerTableHeader>
      </TableCell>
    </PortalCredentialTableRow>
  );
};
